import { UserListComponent } from './user-list.component';

export default UserListComponent;
